// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentModelId } from './EquipmentModel';
import { z } from 'zod';
export const equipmentModelFermentorId = (z.number());
export const equipmentModelFermentor = z.object({
    id: equipmentModelFermentorId,
    equipment_model_id: equipmentModelId,
    nominal_volume_l: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const equipmentModelFermentorInitializer = z.object({
    id: equipmentModelFermentorId.optional(),
    equipment_model_id: equipmentModelId,
    nominal_volume_l: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const equipmentModelFermentorMutator = z.object({
    id: equipmentModelFermentorId.optional(),
    equipment_model_id: equipmentModelId.optional(),
    nominal_volume_l: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=EquipmentModelFermentor.js.map